import React from 'react';
import { useUser } from '@lore/auth';
import ParentLayout from '../Layout';
import Urls from '../Urls';
import Form from './Form';
import { Helmet } from 'react-helmet-async';
import useRouter from '../../../hooks/useRouter';
import useSetupNavigation from '../useSetupNavigation';

export default function Layout(props) {
  const { history } = useRouter();
  const user = useUser();

  const navigation = useSetupNavigation(Urls.FINISH);

  return (
    <ParentLayout>
      <Helmet>
        <title>Setup - Finish - Redirect Educator</title>
      </Helmet>
      <Form
        user={user}
        navigation={navigation}
        onPrevious={(newData) => history.push(Urls.AVATAR)}
        onNext={() => history.push(Urls.DASHBOARD)}
        onSkip={() => history.push(Urls.DASHBOARD)}
      />
    </ParentLayout>
  );
};
